import React, { useCallback } from 'react';
import createUseContext from 'constate';

const ACTION_TYPE = {
  START: 'START',
  END: 'END',
};

const initialState = {
  isFinished: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.START:
      return {
        isFinished: false,
      };
    case ACTION_TYPE.END:
      return {
        isFinished: true,
      };
    default:
      throw new Error();
  }
};

const useProgress = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const {
    isFinished,
  } = state;
  const start = useCallback(() => {
    dispatch({
      type: ACTION_TYPE.START,
    });
  }, [dispatch]);

  const end = useCallback(() => {
    dispatch({
      type: ACTION_TYPE.END,
    });
  }, [dispatch]);

  return {
    isFinished,
    start,
    end,
  };
};

const [ProgressProvider, useProgressContext] = createUseContext(useProgress);

export {
  ProgressProvider,
  useProgressContext,
};
